import React from 'react';
import { useStore } from '../../../store';
import './component014.less';

import AddPointIcon from '../../../../../assets/animation-arrow.gif';

interface IComponent014Props {
  content1: string;
  content2: string;
  content3: string;
  className: string;
}

const Component014: React.FunctionComponent<IComponent014Props> = ({
  content1,
  content2,
  content3,
  className,
}) => {
  const { language } = useStore();
  const videoRef = React.useRef() as React.MutableRefObject<HTMLVideoElement>;
  const videoContainerRef =
    React.useRef() as React.MutableRefObject<HTMLDivElement>;
  return (
    <div className={`example component ${className}`}>
      <span
        className="example-label"
        dangerouslySetInnerHTML={{ __html: content1 }}
      />
      <span className="link-label">
        <img src={AddPointIcon} alt="" />
        {content2}
      </span>
      <a
        className="example-link"
        href="https://cyberdefender.hk/password-strength-tool/"
        target="_blank"
        rel="noreferrer"
        dangerouslySetInnerHTML={{ __html: content3 }}
      />
      <div ref={videoContainerRef} className="video-container">
        <div className="video-loading">Loading...</div>
        <video
          key={language}
          ref={videoRef}
          width="100%"
          controls={true}
          autoPlay={false}
        >
          <source
            src={
              language === 'cn'
                ? '/videos/password-strength-tool.mp4'
                : '/videos/password-strength-tool-en.mp4'
            }
            type="video/mp4"
          />
          Your browser does not support HTML video.
        </video>
      </div>
    </div>
  );
};

export default Component014;
